/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientClinicDateTypename = "PatientClinicDate" as const;

/**
 *
 * @export
 * @interface PatientClinicDate
 */
export interface PatientClinicDate {
  /**
   *
   * @type {string}
   * @memberof PatientClinicDate
   */
  date?: string;
  /**
   *
   * @type {number}
   * @memberof PatientClinicDate
   */
  slotNumber?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientClinicDate
   */
  readonly __typename?: string;
}

export function PatientClinicDateFromJSON(json: any): PatientClinicDate {
  return PatientClinicDateFromJSONTyped(json, false);
}

export function PatientClinicDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientClinicDate {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientClinicDateTypename,

    date: !exists(json, "date") ? undefined : json["date"],
    slotNumber: !exists(json, "slot_number") ? undefined : json["slot_number"],
  };
}

export function PatientClinicDateToJSON(object?: PatientClinicDate | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    date: value.date,
    slot_number: value.slotNumber,
  };
}
